import { render } from "./BPTMenu.vue?vue&type=template&id=56e8bd18"
const script = {}

import "./BPTMenu.vue?vue&type=style&index=0&id=56e8bd18&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__